import styled from 'styled-components';

export const Container = styled.div`
  padding: 42px;
  background: white;

  max-width: 750px;

  header {
    text-align: center;
    padding-bottom: 42px;
    border-bottom: 1px solid #EBEBEB;

    img {
      width: 218px;
      margin-bottom: 32px;
    }

    h2 {
      font-size: 1.625rem;
      font-weight: 700;
      line-height: 16px;
    }
  }

  body {
    div {
      background: white;

      padding: 32px 20px;
      border-bottom: 1px solid #EBEBEB;
    }

    span {
      font-size: 1.125rem;
      font-weight: 600;
      line-height: 33.5px;
      color: #F58025;
      text-decoration: underline;
    }
  }

  footer {
    text-align: center;
    padding: 52px 10px 0px;

    font-weight: 400;
    font-size: 0.875rem;
    line-height: 33.5px;

    color: #9D9D9D;

    p {
      line-height: 20px;
    }
  }
`;

export const Row = styled.tr<{ margin?: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: ${({ margin }) => (margin ? '6px' : null)};
`;
